import { useContext, useEffect, useState, useRef } from "react";
import { InputForm, QuizSelectForm, QuizTimeUnit, QuizWeight , SimpleTextAreaForm, TextAreaForm} from "../atoms/input";
import { TypeContent } from "./typeContent";
import { CreateQuizFactory } from "../factory/createQuizFactory";
import { CreateText } from "./createText";
import { HorizontalLayout, VerticalLayout } from "./layout";
import { deleteAPI, fetchAPI, getAPI, postAPI, updateAPI, ip, postAPImedia } from "../api/api";
import { ButtonGroup, IconButton, StandardButton } from "../atoms/buttons";
import { Alert } from "./alert";
import { Spinner } from "../atoms/spinner";
import { PageContext } from "../App";
import { IconText } from "./courseComp";
import { Skills } from "../molecule/Skills";
import { borderRadius, padding } from "polished";
import { AISettingsModal, SuggestedSkillsModal } from "./customModals";
import { VideoPlayer } from "../atoms/video";
import { VideoModule } from "../molecule/VideoModule";
import { set } from "date-fns";
import { TitleDescriptionText } from "../atoms/titleDescription";
import { CreateAvatarComp } from "./createAvatarComp";

export function CreateLessonComp({ allSkills, type, content, create, lessonID, id_module, title, data, loading, setLoading, updateContent, skills, loadSkills, setSkills, generateAiContent, onImageDrop }) {
  const [lesson, setLesson] = useState("");
  const [aiSettings, setAiSettings] = useState({})
  const [aiSelected, setAiSelected] = useState(false);
  const [message, setMessage] = useState("");
  const [aiGenerating, setAiGenerating] = useState(false);
  const [loadingSkill, setLoadingSkill] = useState(false);
  const [generatedContent, setGeneratedContent] = useState(null);
  const [textInput, setTextInput] = useState("");
  const [newLessonID, setNewLessonID] = useState(lessonID);
  const navigationContext = useContext(PageContext);
  const [skillMessage, setSkillMessage] = useState("");
  const [suggestedSkills, setSuggestedSkills] = useState([]);
  const [showAISettingsModal, setShowAISettingsModal] = useState(false);
  const [isDraggingFiles, setIsDraggingFiles] = useState(false);
  const dragCounter = useRef(0);


  const filteredSkills = (skills || []).filter(s => s.id_modules === id_module);
  const handleTextInputChange = (text) => {
    const url = insertYoutubeEmbed(text);
    setTextInput(url);
  };


  const chooseType = (event, value) => {
    event.stopPropagation();

    setLesson(value[0]);
    create(event, value[1]);
  };

  const toggleAISelection = () => {
    setAiSelected(!aiSelected);
    setMessage(!aiSelected ? "Gebruik het tandwieltje in de AI-knop om de instellingen te configureren. Klik daarna op een module om automatisch content te genereren." : "");
  };

  const generateContent = async (lessonTypeParam) => {
    setAiGenerating(true);
    setLoading(true);
    setAiSelected(false);
    setMessage("");
    await generateAiContent(aiSettings, lessonTypeParam)
    setAiGenerating(false);
    setLoading(false);
    setAiSelected(false);

  };

  const handleSkillChange = async (newSkillName) => {
    setLoadingSkill(true);
    const query = "api/courses/lessons/modules/skills/update";
    const body = { id_modules: id_module, skill_names: newSkillName, id_lessons: newLessonID || lessonID, };
    const res = await updateAPI(query, body);
    if (res.status === "ok") {
      loadSkills();
    }
    setLoadingSkill(false);
  };

  const handleSkillRemove = async (skill) => {
    setLoadingSkill(true);
    const query = "api/courses/lessons/modules/skills/remove";
    const body = { id_modules: id_module, id_skill: skill.id_skill, id_lessons: newLessonID || lessonID, };
    const res = await deleteAPI(query, body);
    if (res.status === "ok") {
      loadSkills();
    }
    setLoadingSkill(false);
  };
  function globalQuizSkillCheck(allSkills, currentModuleId) {
    const quizSkills = new Set();
    const contentSkills = new Set();

    for (const skill of allSkills) {
      if (skill.id_modules === currentModuleId) {
        if (skill.id_type === 1) quizSkills.add(skill.skill_name.trim());
      } else if (skill.id_type === 2 || skill.id_type === 3) {
        contentSkills.add(skill.skill_name.trim());
      }
    }

    const missing = [...quizSkills].filter(skill => !contentSkills.has(skill));

    if (missing.length) {
      const msg = missing.map(name => `"${name}"`).join(", ");
      setSkillMessage(`De volgende quiz skills zijn niet gekoppeld aan een tekst of video module: ${msg}. Overweeg om ze ook daar toe te voegen voor betere context.`);
    } else {
      setSkillMessage("");
    }
  }

  const loadSuggestions = async () => {
    setLoadingSkill(true);
    const query = "api/courses/lessons/modules/skills/suggest";
    const moduleContent = generatedContent || content || data?.module_content;

    const body = {
      id_module: id_module,
      id_lessons: newLessonID || lessonID,
      id_course: navigationContext.sidebar.courseID,
      module_content: moduleContent,
      module_title: data.title_lesson || title,
      module_type: data.module_type || getLessonTypeAsInt()
    }

    const res = await postAPI(query, body);
    if (res.status === "ok") {
      setSuggestedSkills(res.data || []);

    } else {
      setSuggestedSkills([]);
    }
    setLoadingSkill(false);
  }


  const getLessonTypeAsInt = () => {
    if (type !== 0) return type;
    const map = { quiz: 1, text: 2, video: 3 };
    return map[lesson];
  };
  useEffect(() => {
    globalQuizSkillCheck(allSkills, id_module);
  }, [allSkills, id_module]);
  useEffect(() => {
    loadSkills();
  }, [id_module]);

  useEffect(() => {
    if (!content) return;
    const hasBlocks = Array.isArray(content?.blocks) && content.blocks.length > 0;
    const shouldPrefill = (lesson === "text" || type === 2) && !generatedContent && (!textInput || textInput.length === 0);
    if (hasBlocks && shouldPrefill) {
      setGeneratedContent(content);
    }
  }, [content, lesson, type, generatedContent, textInput]);

  const isSelectingModuleType = (type === 0 && lesson === "") && !generatedContent && !aiGenerating;

  const hasImageFile = (dataTransfer) => {
    if (!dataTransfer) return false;
    const items = dataTransfer.items ? Array.from(dataTransfer.items) : [];
    if (items.length > 0) {
      return items.some(item => item.kind === "file" && /image\/(png|jpeg)/i.test(item.type));
    }
    const files = dataTransfer.files ? Array.from(dataTransfer.files) : [];
    return files.some(file => /image\/(png|jpeg)/i.test(file.type));
  };
  const isAcceptedImageFile = (file) => {
    if (!file) return false;
    if (file.type && /image\/(png|jpeg)/i.test(file.type)) {
      return true;
    }
    return /\.(png|jpe?g)$/i.test(file.name || "");
  };

  useEffect(() => {
    if (!isSelectingModuleType && (isDraggingFiles || dragCounter.current !== 0)) {
      dragCounter.current = 0;
      setIsDraggingFiles(false);
    }
  }, [isSelectingModuleType, isDraggingFiles]);

  const handleDragEnter = (event) => {
    if (!isSelectingModuleType || !hasImageFile(event.dataTransfer)) return;
    event.preventDefault();
    dragCounter.current += 1;
    setIsDraggingFiles(true);
  };

  const handleDragOver = (event) => {
    if (!isSelectingModuleType || !hasImageFile(event.dataTransfer)) return;
    event.preventDefault();
  };

  const handleDragLeave = (event) => {
    if (!isSelectingModuleType) return;
    event.preventDefault();
    dragCounter.current = Math.max(0, dragCounter.current - 1);
    if (dragCounter.current === 0) {
      setIsDraggingFiles(false);
    }
  };

  const handleDrop = (event) => {
    if (!isSelectingModuleType) return;
    event.preventDefault();
    const files = Array.from(event.dataTransfer?.files || []);
    const imageFiles = files.filter(isAcceptedImageFile);
    dragCounter.current = 0;
    setIsDraggingFiles(false);
    if (imageFiles.length === 0) {
      return;
    }
    setLesson("text");
    onImageDrop?.(imageFiles);
  };

  return (
    <div data-testid={'create-lesson-comp-1'}>
      <div className="horizontal" style={{ alignItems: "flex-start", }}>
        <VerticalLayout>
          <p className="small-text-dark semi-bold">Selecteer Les Type</p>
          <div
            className="horizontal standard-margin-top standard-margin-right standard-small-margin-bottom phone-quiz-selector module-type-dropzone"
            data-testid={'create-lesson-comp-1-list'}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            {isSelectingModuleType && isDraggingFiles && (
              <div className="module-drop-overlay">
                <p className="small-text-light">Laat los om automatisch een tekstmodule aan te maken met de afbeelding(en).</p>
              </div>
            )}
            <TypeContent
              aiSelected={aiSelected}
              selected={{ selected: lesson === "video" || type === 3, chosen: lesson !== "" || type !== 0 }}
              onClick={(e) => { if (generatedContent && loading) return; aiSelected ? generateContent("video") : chooseType(e, ["video", 3]); }}
              icon="add-video" title="Video"
              aiGenerating={aiGenerating}

            />
            <TypeContent
              aiSelected={aiSelected}
              selected={{ selected: lesson === "text" || type === 2, chosen: lesson !== "" || type !== 0 }}
              onClick={(e) => { if (generatedContent || lesson?.length > 0) return; aiSelected ? generateContent("text") : chooseType(e, ["text", 2]); }}

              icon="text-size" title="Text"
              aiGenerating={aiGenerating}
            />
            <TypeContent
              aiSelected={aiSelected}
              selected={{ selected: lesson === "quiz" || type === 1, chosen: lesson !== "" || type !== 0 }}
              onClick={(e) => { if (generatedContent || content?.length > 0) return; aiSelected ? generateContent("quiz") : chooseType(e, ["quiz", 1]); }}
              icon="mail" title="Quiz"
              aiGenerating={aiGenerating}
            />
            {lesson === "" && type === 0 && (
              <TypeContent
                selected={{ selected: aiSelected, chosen: aiSelected }}
                showAIsetting={aiSelected}
                icon="wand"
                onClick={title?.trim() ? () => toggleAISelection() : () => setMessage("Voer eerst een titel in.")}
                title="AI" aiSelected={aiSelected} aiGenerating={aiGenerating}
                openAISettings={() => setShowAISettingsModal(true)}
              />
            )}
            {generatedContent && !loading && (
              <div onClick={() => generateContent(lesson)} className="standard-margin-top refresh">
                <IconText
                  icon2="refresh"
                  tooltip="Genereer opnieuw met AI"
                />
              </div>
            )}
          </div>
        </VerticalLayout>
      </div>
      {(lesson === "quiz" || type === 1) && skillMessage && !loadingSkill && (<Alert dismissable={() => setSkillMessage("")} className="standard-margin-bottom" type="warning" title="Tip!" message={skillMessage} />)}
      {message && (
        <Alert
          className="standard-margin-bottom"
          type="warning"
          title="Let op!"
          message={message}
        />
      )}
      <AISettingsModal onSave={(DataToSave) => { setAiSettings(DataToSave); setShowAISettingsModal(false); }} visible={showAISettingsModal} onClose={() => setShowAISettingsModal(false)} />
      {aiGenerating && loading ? (
        <div className="ai-spinner-background">
          <Spinner size="5rem" thickness="2px" color="primary-600" className="ai-spinner" />
          <p className="small-text-light ai-spinner-text">Even geduld, inhoud wordt gegenereerd...</p>
        </div>
      ) : (
        <FactoryLessons
          lessonID={newLessonID}
          id_module={id_module}
          content={textInput || generatedContent || content}
          lesson={lesson || type}
          data={data}
          textInput={textInput || generatedContent || content?.media_url || ""}
          setTextInput={handleTextInputChange}
          aiGenerating={aiGenerating}
          updateNewContent={(data) => updateContent(data)}
        />
      )}
      {content && (<HorizontalLayout className="skills-comp standard-margin-top relative" style={{boxShadow:" rgba(0, 0, 0, 0.09) 0px 4px 4px, inset rgba(255, 255, 255, 0.09) 0px 4px 4px ", overflow: "hidden", width: "auto", height: "auto", gap: "1rem", border: "1px solid var(--border-color)", borderRadius: "calc(10px * var(--br-scale))", alignItems: "flex-start", }}>
        <Skills suggestedSkills={suggestedSkills} loadSuggestions={loadSuggestions} setLoading={setLoadingSkill} loading={loadingSkill} setSkills={setSkills} skills={filteredSkills} onAddSkill={handleSkillChange} onRemoveSkill={handleSkillRemove} id_module={id_module} id_lessons={newLessonID} />
      </HorizontalLayout>)}
    </div>
  );
}

export const UpDownButton = ({ icon, onClick }) => (
  <IconButton onClick={onClick} className="simple-up-down" icon2={icon} />
);

export function FactoryLessons({lesson, content, lessonID, id_module, data, setTextInput, textInput, updateNewContent }) {
  const [quizType, setQuizType] = useState(1);
  const [loading, setLoading] = useState(false);
  const [videoLoading, setVideoLoading] = useState(false);

  const saveText = async (content) => {
    // setTextInput(content);
    updateContent(content, "text_content", 2);
  };



  const generateVideoUrl = async () => {
    setLoading(true);
    const video = await getAPI(`api/courses/lessons/${lessonID}/generate-video`);
    setLoading(false);

    if (video.status === "ok") {
      const url = video.data.url;
      setTextInput(url);
    }
  };


  function secureFilename(name) {
    return name.trim().replace(/\s+/g, '_');
  }
  const handleVideoUpload = async (file) => {
    setVideoLoading(true);

    const cleanName = secureFilename(file.name);
    const formData = new FormData();
    formData.append("video", file);
    const videoUrl = `${ip}/uploads/videos/${cleanName}`;
    formData.append("media_url", videoUrl);
    formData.append("id_modules", id_module);

    const res = await postAPImedia("api/media/add-video", formData);

    if (res.status === "ok") {
      setTextInput(res.data);
    } else {
      console.error("Upload failed:", res);
    }
    setVideoLoading(false);

  };

  const updateContent = async (content2, type_content, type_id) => {

    const body = {
      module_content: { [type_content]: content2 },
      id_lessons: lessonID,
      id_modules: content?.id_modules || id_module,
      module_type: type_id,
    };

    const update = await updateAPI("api/courses/lessons/modules/update", body);
    if (update.status === "ok") {
      console.log("Update successful", update);
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      handleVideoUpload(file);

    }
    e.target.value = "";
  };
  const saveVideo = async (content) => {
    const url = insertYoutubeEmbed(content);
    updateContent(url, "media_url", 3);
  };
  switch (lesson) {
    case 3:
    case "video":
      return (
        <VerticalLayout style={{ height: "auto" }}>
          {videoLoading ? (<HorizontalLayout className="video-spinner standard-margin-bottom"><Spinner size="5rem" thickness="2px" color="primary-600" /></HorizontalLayout>) : (<VideoModule src={textInput || (content?.video_url ? content.video_url : null)} onUpload={handleFileChange} />)}
          <InputForm
            loading={loading}
            onClick={generateVideoUrl}
            generate={true}
            typeInput={(text) => { saveVideo(text); setTextInput(text) }}
            value={textInput || (content?.video_url ? content.video_url : "")}
            title="Video"
            placeholder="Url video"
            upload={true}
            uploadClick={handleFileChange}
          />
        </VerticalLayout>
      );
    case 1:
    case "quiz":
      return (
        <CreateQuizFactory
          completeData={data}
          data={content}
          type={quizType}
          lessonID={lessonID}
          moduleID={id_module}
          updatedContent={(value) => updateNewContent(value)}
        />
      );
    case 2:
    case "text":
      return (
        <VerticalLayout style={{height:"auto", gap:"1rem"}}>
          
          <CreateText
            defaultData={content}
            textinput={textInput}
            onTextChange={saveText}
          />
          <CreateAvatarComp id_module={id_module} moduleContent={textInput} />

        </VerticalLayout>

      );
    default:
      return null;
  }
}



const insertYoutubeEmbed = (url) => {
  const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=)?([a-zA-Z0-9_-]{11})/;
  const match = url.match(youtubeRegex);
  if (match && match[5]) {
    const videoId = match[5];
    return `https://www.youtube.com/embed/${videoId}`;
  }
  return url;
}
